"use strict";
/**
 * The order page's position across the primary and its parallel legs
 * (ai/PARALLEL_LEGS_PLAN.md §3). Display only: sells and sizing read the
 * primary's own position.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.combinePositions = combinePositions;
const round2 = (n) => Math.round(n * 100) / 100;
/**
 * Every venue counts contracts that pay $1, so legs add directly; a YES and a
 * NO on the same outcome pay $1 either way, so they net.
 */
function combinePositions(primary, legs) {
    let yes = primary.yes_quantity || 0;
    let no = primary.no_quantity || 0;
    let unknownLegs = 0;
    let staleLegs = 0;
    for (const leg of legs) {
        if (!leg.position) {
            unknownLegs += 1;
            continue;
        }
        if (leg.stale)
            staleLegs += 1;
        const legYes = leg.position.yes_quantity || 0;
        const legNo = leg.position.no_quantity || 0;
        yes += leg.invert ? legNo : legYes;
        no += leg.invert ? legYes : legNo;
    }
    const net = round2(yes - no);
    return { yes: Math.max(net, 0), no: Math.max(-net, 0), legs: legs.length, unknownLegs, staleLegs };
}
